export enum EmptyScreenOptions {
  NoMessages,
  HaveMessages,
}

export enum InboxFolderTypes {
  sent = 'sent',
  received = 'received',
}
